import React, { useEffect, useState } from "react";
import ChronicConditionService from "../../Services/ChronicConditionService";
import dayjs from "dayjs";
import { HSdecrypt } from "../../utils/encryptPassword";

function ChronicCondition(props) {
  const [chronicConditions, setChronicConditions] = useState([]);

  useEffect(() => {
    PatientchronicConditions();
  }, [props.selectedPatient]);

  const PatientchronicConditions = () => {
    let payload = {
      patientId: props.selectedPatient,
    };
    ChronicConditionService.HSPatientchronicConditions(payload)
      .then((result) => {
        const decryptedData = HSdecrypt(result.data.data);
        setChronicConditions(JSON.parse(decryptedData));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div
      className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
      id="unquie-scroll"
    >
      <div className="flex justify-between items-center p-3">
        <h3 className="text-sm font-bold text-gray-700">Chronic Conditions</h3>
        <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
          {/* <HiPlusCircle className="text-primaryColor w-7 h-7"/> */}
        </div>
      </div>
      <hr />
      <div className="h-60 p-3 overflow-y-scroll flex flex-col gap-3 scrollWidth">
        {chronicConditions.length > 0 ? (
          chronicConditions.map((user, i) => (
            <div className="relative">
              <div className="overflow-y-scroll pr-2 scrollWidth flex flex-col gap-2">
                <div className="bg-[#FAFFF7] border border-[#B7EE9E] border-l-4 rounded-lg p-3 text-xs text-gray-700 flex flex-col gap-2">
                  <p>
                    <strong> ChronicCondition: </strong>
                    {user.chronicDescription}
                  </p>
                  <p>
                    Onset Date : {dayjs(user.givenDate).format("YYYY-MM-DD")}
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div></div>
        )}
      </div>
    </div>
    // <div>
    //   <div className=" w-full max-w-[370px] h-[300px] sm:h-[340px] md:h-[370px] md:m-5 border rounded-lg">
    //     <div className="h-[13%] bg-secondaryColor flex items-center justify-center rounded-md p-2">
    //       <h1 className="font-bold text-normal text-white mt-3">
    //         Chronic Conditions
    //       </h1>
    //     </div>
    //     <div className="h-[75%] overflow-y-auto bg-white scrollwidth border-2 ">
    //       {chronicConditions.length > 0
    //         ? chronicConditions.map((user, i) => (
    //             <div className="items-center text-sm p-2 m-3 border rounded-md">
    //               <div className="font-semibold">
    //                 ChronicCondition:
    //                 <span className="font-medium text-gray-500">
    //                   {" "}
    //                   {user?.chronicDescription}
    //                 </span>
    //               </div>
    //               <div className="ml-auto font-medium mt-2 flex justify-start">
    //                 <h5 className="text-gray-500 font-semibold text-sm">
    //                   Onset date:{" "}
    //                   <span>{dayjs(user.givenDate).format("YYYY-MM-DD")}</span>
    //                 </h5>
    //               </div>
    //             </div>
    //           ))
    //         : null}
    //     </div>
    //     <div className="footer h-[44px] bg-secondaryColor rounded-md"></div>
    //   </div>
    // </div>
  );
}

export default ChronicCondition;
